<div class="page__header">
  <div class="page__header-flex">
    <div class="page__header-left" (click)="route.navigate(['/dashboard'])" style="cursor: pointer">
      <div class="logo">
        <img class="logo__image" src="assets/logos/freely-logo-black.svg" alt="History" style="width: 200px; height: auto;"/>
        <div class="logo__slogan">accept</div>
      </div>
    </div>
    <div class="page__header-right">
      <button mat-stroked-button (click)="goBack()">exit</button>
    </div>
  </div>
</div>
<form class="form" [formGroup]="form" (ngSubmit)="onSubmit()">
  <app-payment-collect-stepper
    #stepper
    [form]="form"
    [allowNext$]="$allowNext"
    [selectedIndex]="entryContext ? 2 : 0"
    (selectionChange)="$event.selectedIndex === 0 && (customerStepOpened = true)"
  >
    <cdk-step>
      <h2 class="step-title">From which customer would you like to collect payment?</h2>
      <p class="step-subtitle">
        <button
          *ngIf="isBulkPaymentEnabled"
          type="button"
          mat-button color="primary"
          (click)="openBulkPaymentWizard()"
        >bulk payment wizard
        </button>
        <button
          *ngIf="isNachaWizardEnabled"
          type="button"
          mat-button color="primary"
          (click)="openNachaWizard()"
        >process nacha file
        </button>
        <button
          *ngIf="isFlashOnboardEnabled"
          type="button"
          mat-button color="primary"
          (click)="openSelfOnboardCustomerModal()"
        >self onboard customer
        </button>
        <button
          *ngIf="!isAddCustomerDisabled"
          type="button"
          mat-button color="primary"
          (click)="openAddCustomerModal()"
        >add customer
        </button>
        <button
        *ngIf="isAdhocInvoiceAllowed"
        type="button"
        mat-stroked-button
        color="monochrome"
        (click)="skipToInvoiceDetails()"
      >
        use one-time payment
      </button>
      </p>
      @if (customerStepOpened) {
        <app-payment-collect-customers
          formControlName="customer"
          [parent]="this"
        />
      }
    </cdk-step>
    <cdk-step>
      <h2 class="step-title">
        {{ isFlashPay
          ? 'A flashpay link will be sent to the customer for payment'
          : isOneTimePay
            ? 'Which card should be charged for a one-time payment?'
            : isOneTimeCard
              ? 'Enter one-time card details'
              : isAchPayEnabled
                ? 'Which account should be charged?'
                : 'Which card should be charged?'
        }}
      </h2>
      <app-selected-customer
        [customer]="form.controls.customer.value"
        [canChange]="canChangeCustomer"
        (changeCustomer)="stepper.selectedStep = 'customer'"
      />
      <p class="step-subtitle">
        <button
          type="button"
          mat-stroked-button [color]="isOneTimeCard ? 'monochrome-inversed' : 'monochrome'"
          matTooltip="enter card details for a one-time charge (not saved on file)"
          matTooltipPosition="above"
          (click)="toggleOnetimeCard()"
          *ngIf="!isFlashPay && !isOneTimePay"
        >
          @if (!isOneTimeCard) {
            one-time card
          } @else {
            using one-time card
          }
          <mat-icon iconPositionEnd>credit_card</mat-icon>
        </button>
        <button
          type="button"
          mat-stroked-button [color]="isFlashPay ? 'monochrome-inversed' : 'monochrome'"
          matTooltip="emails a payment link to recipient"
          matTooltipPosition="above"
          [class.flashpay]="isFlashPay"
          (click)="toggleFlashPay()"
          *ngIf="(isFlashPayEnabled || isAdvancedFlashPayEnabled) && !isOneTimePay && !isOneTimeCard"
        >
          @if (!isFlashPay) {
            use <i>flash</i> pay
          } @else {
            using <i>flash</i> pay
          }
          <mat-icon iconPositionEnd>bolt</mat-icon>
        </button>
        @if (isOneTimePay) {
          <button
            type="button"
            mat-stroked-button [color]="isOneTimePay ? 'monochrome-inversed' : 'monochrome'"
            (click)="resetToCustomerStep()"
          >
            using one-time payment
          </button>
        }
      </p>
      <app-payment-collect-payment-methods
        [parent]="this"
        [isOneTimePay]="isOneTimePay"
        [isOneTimeCard]="isOneTimeCard"
        [formControl]="paymentFormControl"
        (oneTimePaymentValidated)="$allowNext = $event"
        (addCard)="openAddPaymentMethodModal()"
        (addAchAccount)="openAddAchPaymentMethodModal()"
      />
    </cdk-step>
    <cdk-step>
      <h2 class="step-title">
        {{ getInvoiceDetailsStepTitle() }}
      </h2>
      <app-selected-customer
        [customer]="form.controls.customer.value"
        [canChange]="canChangeCustomer"
        (changeCustomer)="stepper.selectedStep = 'customer'"
      />
      <p class="step-subtitle">
        @if (isFlashPay) {
        <button
          type="button"
          mat-stroked-button [color]="isFlashPay ? 'monochrome-inversed' : 'monochrome'"
          matTooltip="emails a payment link to recipient"
          matTooltipPosition="above"
          ngClass="button-as-badge-active"
          [class.flashpay]="isFlashPay"
          (click)="toggleFlashPay()"
          disabled
        >
          using <i>flash</i> pay<mat-icon iconPositionEnd>bolt</mat-icon>
        </button>
        }
        @if (isAchPay) {
        <button
          type="button"
          mat-stroked-button color="monochrome-inversed"
          ngClass="button-as-badge-active"
          class="achpay"
          disabled
        >
          paying by <i>ACH</i><mat-icon iconPositionEnd>account_balance</mat-icon>
        </button>
        }
        @if (isOneTimePay) {
          <button
            type="button"
            mat-stroked-button [color]="isOneTimePay ? 'monochrome-inversed' : 'monochrome'"
            (click)="resetToCustomerStep()"
          >
            using one-time payment
          </button>
        }
      </p>
      <app-invoice-details 
        #invoiceDetails
        formControlName="invoice"
        [paymentForm]="paymentFormControl"
        [customerFormControl]="form.controls.customer"
        [preSelectedInvoiceId]="entryContext?.invoiceId ?? null"
        [startInMultiInvoiceMode]="!!entryContext">
      </app-invoice-details>
    </cdk-step>
    <cdk-step>
      <h2 class="step-title summary">Final step. Does everything look correct?</h2>
      <app-summary [form]="form" (editClick)="stepper.selectedStep=$event"/>
    </cdk-step>
  </app-payment-collect-stepper>
</form>
